
import * as SignaturePad from '../../../node_modules/signature_pad/dist/signature_pad.js';

$(document).ready(function(e){
	if ($('.signature-field').length > 0){
		$('.signature-field').each(function(){
			var dom = $(this);
			var input = dom.find('.signature-field__input');
			var canvas = dom.find('.signature-field__canvas-wrapper canvas');
			var signaturePad = new SignaturePad(canvas[0]);
			
			// Load any pre-existing data into our signature pad
			if (input.val() != ''){
				signaturePad.fromDataURL(input.val());
			}
			
			canvas.on('mouseup', function(e){
				input.val(signaturePad.toDataURL());
			});
			
			canvas.on('touchend', function(e){
				input.val(signaturePad.toDataURL());
			});
			
			dom.find('.signature-field__clear-button').on('click', function(e){
				input.val('');
				signaturePad.clear();
			});
		});
	}
});